export * from "./index.js";

import type { AutoInitOptions } from "./auto-init.js";
import { autoInit } from "./auto-init.js";
import { installAutoPage } from "./auto-page.js";
import { isAutoPageEnabled } from "./injection-config.js";
import { loadModules } from "./module-loader.js";

declare global {
  interface Window {
    /**
     * Optional runtime config read by the auto-init bundle. Useful for dev
     * (override endpoint) and for passing flushAt/flushInterval/debug
     * without rebuilding. Must be set BEFORE the SDK bundle executes.
     */
    __ETS_CONFIG__?: AutoInitOptions;
  }
}

// Exported so the IIFE namespace (`window.ETS`) carries the instance that
// the loader pattern needs. The interceptor / Layer 0 loader reads
// `window.ETS.instance` after lite executes; without an explicit `export`
// the value would be a module-private const and the loader would see
// `undefined` even when autoInit succeeded.
export const instance = autoInit(
  typeof window !== "undefined" ? window.__ETS_CONFIG__ : undefined,
);

// Fire-and-forget: module loading is async and must not block the main
// boot path. `instance` is undefined if no stub was found, in which case
// there is nothing to `use(plugin)` on.
if (instance) {
  // Auto-pageview: patch pushState/replaceState + popstate/hashchange para
  // emitir page() automático. Default ON; desativado via
  // window.__ETS_CONFIG__.auto_page = false.
  if (isAutoPageEnabled()) {
    installAutoPage(instance);
  }
  void loadModules(instance).catch(() => undefined);
}
